































































import {Component, Prop, Vue} from "vue-property-decorator";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import {Util} from "@/_global/utils";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import NameInputs from "@/components/UI/NameInputs.vue";
import CondimentItem from "@/pages/ItemManagementPage/ItemDetail/CondimentItem.vue";
import ToggleCheckBox from '@/components/UI/ToggleCheckBox.vue'

@Component({
    components: {
        ToggleCheckBox,
        CondimentItem,
        NameInputs,
    }
})
export default class CondimentGroup extends Vue {
    @Prop() private condimentGroupId!: number;

    get deliousCondimentGroup(): Delious.CondimentGroup {
        return DeliousItemsStore.condimentGroupById[this.condimentGroupId] || {};
    }

    get cmsCondimentGroup(): CMS.CondimentGroup {
        return CondimentGroupsStore.condimentGroupById[this.condimentGroupId] || {}
    }

    private isDefaltSelect(itemId: number): boolean {
        const defaultItemId: number = this.cmsCondimentGroup.default_item_id || -1;
        const isDefaultItemExist = this.deliousCondimentGroup.condiment_list.filter(v => v.plu_no == defaultItemId).length > 0;
        if (isDefaultItemExist) {
            // 初期選択商品の設定がされてて、その商品がDelious側のオプショングループ内にあるとき
            return defaultItemId == itemId;
        } else {
            // デフォルト選択商品の設定がだめなときは、最初の１件を選択してることにする。
            return this.deliousCondimentGroup.condiment_list[0].plu_no == itemId;
        }

    }

    private onChangeName(languageCode: string, name: string): void {
        const edited: CMS.CondimentGroup = Util.deepCopy(this.cmsCondimentGroup);
        edited.names[languageCode] = name;
        CondimentGroupsStore.localEdit(edited);
    }

    private onMultiSelectChange(multiSelect: boolean): void {
        const edited: CMS.CondimentGroup = Util.deepCopy(this.cmsCondimentGroup);
        edited.multi_select = multiSelect;
        CondimentGroupsStore.localEdit(edited);
    }

    private onOptionalSelectChange(): void {
        const edited: CMS.CondimentGroup = Util.deepCopy(this.cmsCondimentGroup);
        edited.optional_select = !edited.optional_select;
        CondimentGroupsStore.localEdit(edited);
    }

    private onDefaultSelectChange(itemId:number){
        const edited: CMS.CondimentGroup = Util.deepCopy(this.cmsCondimentGroup);
        edited.default_item_id = itemId;
        CondimentGroupsStore.localEdit(edited);
    }
}
